import { createRootRoute, Outlet } from "@tanstack/react-router";
import { RegistryProvider } from "@effect-atom/atom-react";

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  return (
    <RegistryProvider defaultIdleTTL={60_000}>
      <Outlet />
    </RegistryProvider>
  );
}
